export default class LocationMapUtil {
  constructor(mapService, $filter, gettextCatalog) {
    this.$filter = $filter;
    this.gettextCatalog = gettextCatalog;
    this.mapService = mapService;
    this.lineColor = '#81ca80';
  }

  get pinLocationIcon() {
    return L.icon({
      iconUrl: '/Home/Content/svg/pin.png',
      iconSize: [20, 45],
      iconAnchor: [15, 35],
      clickable: true,
    });
  }

  /**
   * create the controle on topleft to drop a pin
   * @param {*} editableFeatureGroupLayers
   */
  createDrawPinControl(editableFeatureGroupLayers) {
    const options = {
      position: 'topleft',
      draw: {
        polyline: false,
        polygon: false,
        marker: {
          distance: 25,
          icon: this.pinLocationIcon,
        },
        rectangle: false,
        circle: false,
        circlemarker: false,
      },
      edit: {
        featureGroup: editableFeatureGroupLayers,
        edit: false,
        remove: false,
      },
    };

    //Add controls for drawing polygons
    let drawControl = new L.Control.Draw(options);
    L.drawLocal.draw.toolbar.buttons.marker = this.gettextCatalog.getString('Pin Asset Location');
    L.drawLocal.draw.handlers.marker.tooltip.start = this.gettextCatalog.getString(
      'Click map to set the Asset location.',
    );
    return drawControl;
  }

  get pinnedMarkerIcon() {
    return L.divIcon({
      iconSize: [32, 32],
      iconAnchor: [16, 16],
      popupAnchor: [0, 0],
      className: 'last-location-pushpin asset-icon-yellow fa fa-map-marker text-center',
      html: '<div></div>',
    });
  }

  getBluetoothMarkerIcon(zoomLevel) {
    //48.3 =(175-30)/(19-16) =>  (max diameter - min diameter)/(maxzoom -minzoom)
    let diameter = (zoomLevel - 16) * 48.3 + 30;
    diameter = diameter < 30 ? 30 : Math.round(diameter);
    return L.divIcon({
      iconSize: [diameter, diameter],
      iconAnchor: [diameter / 2, diameter / 2],
      popupAnchor: [0, 0],
      className: 'blueTooth-pin-container',
      html: `<div class="blueTooth-pin-range"></div>
            <div class="blueTooth-pin-center"></div>`,
    });
  }

  /**
   * create markup for pinned location popup
   * @param {*} lat
   * @param {*} lng
   * @param {*} time
   */
  generatePinnedMarkerPopup(lat, lng, time, pinned) {
    return `<div class="asset-popup-list-header no-label"></div>
        <div class="container">
        <span class="qv-comm"><strong><i class="fa fa-thumb-tack fa-lg icon fa-fw"></i>&nbsp;${this.gettextCatalog.getString(
          'Location',
        )}:&nbsp;</strong></span>
        <span>${this.$filter('limitTo')(lat, 8, 0)}, ${this.$filter('limitTo')(lng, 9, 0)}</span>
        <br />
        <span class="qv-comm"><strong><i class="fa fa-clock-o fa-lg icon fa-fw"></i>&nbsp;${this.gettextCatalog.getString(
          'Date',
        )}:&nbsp;</strong></span>
        <span>${this.$filter('TableDateFilter')(time)}</span>
        ${
          pinned
            ? `<div class="location-unpin-wrapper">
          <button class="btn btn-primary btn-sm location-unpin">${this.gettextCatalog.getString(
            'Unpin Location',
          )}</button>
        </div>`
            : ''
        }
      </div>`;
  }

  createPinnedMarker(location = {}, gpsStatus, zoomLevel, canUnpin) {
    const icon =
      gpsStatus === 'bluetooth-gps'
        ? this.getBluetoothMarkerIcon(zoomLevel)
        : this.pinnedMarkerIcon;
    const [lng, lat] = location.v || [];
    const marker = new L.Marker([lat, lng], {
      clickable: true,
      doubleClickZoom: false,
      zIndexOffset: 1000,
      icon,
    });

    const popupContent = this.generatePinnedMarkerPopup(
      lat,
      lng,
      location.t,
      canUnpin && gpsStatus === 'pinned-gps',
    );

    /* Adjust marker settings and add the pushpin to its container. */
    marker.bindPopup(popupContent, {
      closeButton: true,
      minWidth: 200,
    });

    return marker;
  }

  breadcrumbMarkerHtml(heading = 0, pointNumber) {
    return `<div class="breadcrumb-pushpin" style="transform: rotate(${heading}deg)">
      </div>
      <span class="breadcrumb-pushpin-caption">${pointNumber}</span>
      <div class="ti-angle-up" style="color:white; text-align:center; width:32px; height:32px; margin-top:-32px; transform: rotate(${heading}deg)"
      </div>`;
  }

  getBreadcrumbMarkerIcon(html) {
    return L.divIcon({
      iconSize: [32, 32],
      iconAnchor: [16, 16],
      popupAnchor: [0, 0],
      className: 'breadcrumb-pushpin-container',
      html: html,
    });
  }

  generatebreadcrumbMarkerPopup(lat, lng, time, attrs = {}) {
    const { heading, speed = null, speed_uom = '', distance = null } = attrs;

    const speedRow =
      speed != null
        ? `<span class="qv-comm">
    <strong><i class="fa fa-tachometer fa-lg icon fa-fw"></i>&nbsp;${this.gettextCatalog.getString(
      'Speed',
    )}:&nbsp;</strong>
    </span>
    ${this.$filter('number')(speed, 2)}&nbsp;${speed_uom}`
        : '';

    const distanceRow =
      distance !== null
        ? ` <span class="qv-comm">
    <strong><i class="fa fa-arrows-h fa-lg icon fa-fw"></i>&nbsp;${this.gettextCatalog.getString(
      'Distance',
    )}:&nbsp;</strong>
    </span>
    <span>${this.$filter('number')(distance, 2)}'&nbsp;ft</span>`
        : '';

    return `<div class="asset-popup-list-header no-label"></div>
    <div class="container">
    <span class="qv-comm">
    <strong><i class="fa fa-location-arrow fa-lg icon fa-fw"></i>&nbsp;${this.gettextCatalog.getString(
      'Location',
    )}:&nbsp;</strong>
    </span>
    <span>${this.$filter('limitTo')(lat, 8, 0)}, ${this.$filter('limitTo')(lng, 9, 0)}</span>
    <br />
    <span class="qv-comm">
    <strong><i class="fa fa-clock-o fa-lg icon fa-fw"></i>&nbsp;${this.gettextCatalog.getString(
      'Date',
    )}:&nbsp;</strong>
    </span>
    <span>${this.$filter('TableDateFilter')(time)}</span>
    <br />
    <span class="qv-comm">
    <strong><i class="fa fa-compass fa-lg icon fa-fw"></i>&nbsp;${this.gettextCatalog.getString(
      'Heading',
    )}:&nbsp;</strong>
    </span>
    <span>${Math.ceil(100 * heading) / 100}</span>
    <br />
    ${speedRow}
    <br />
    ${distanceRow}
    </div>
    `;
  }

  createBreadcrumbMarker(location = {}, index = 0) {
    const { heading = 0 } = location.attrs || {};
    const [lng, lat] = location.v || [];
    const html = this.breadcrumbMarkerHtml(heading, index + 1);

    const marker = new L.Marker([lat, lng], {
      title: index,
      clickable: true,
      doubleClickZoom: false,
      zIndexOffset: 1000 - index,
      icon: this.getBreadcrumbMarkerIcon(html),
    });
    return marker;
  }

  /**
   * draw line between markers
   * @param {*} locationsData gps series data history
   */
  createPolylinesLayer(locationsData = []) {
    const pointList = locationsData.map((gpsLocation) => {
      const [lng, lat] = gpsLocation.v || [];
      return new L.LatLng(lat, lng);
    });

    const polyline = new L.polyline(pointList, {
      color: this.lineColor,
      weight: 2,
      opacity: 0.75,
      smoothFactor: 1,
    });
    return polyline;
  }
}
